import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Card,
  Avatar,
  TextField,
} from "@mui/material";
import { useDrag } from "react-dnd";
import ClientReviewModel from "../../../components/modals/ClientReviewModel";
import { $crud } from "../../../utils/CrudFactory";

import StarIcon from "@mui/icons-material/Star";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toLocalTime, toUTCTime } from "../../../helper/functions";

const OtherReviewClient = ({
  onDrop,
  showAllReviews,
  onViewAllClick,
  dateFilter,
  setDateFilter,
  reviews,
  setReviews,
}) => {
  const visibleReviews = showAllReviews ? reviews : reviews.slice(0, 4);

  return (
    <Grid container>
      {!showAllReviews && (
        <>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontSize: "24px",
                color: "#673C8E",
              }}
            >
              Latest Reviews
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 400,
                fontSize: "12px",
                color: "#A3A3A3",
              }}
            >
              Reviews From Vpickup Clients{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} sx={{ textAlign: "right" }}>
            <Box
              display="flex"
              alignItems={"center"}
              gap="8px"
              justifyContent={"end"}
            >
              <Box
                sx={{
                  width: "38%",
                  paddingLeft: "6px",
                  display: "flex",
                  borderRadius: "4px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                  // border: "2px solid rgba(103, 60, 142, 1)",
                }}
              >
                <Typography
                  sx={{ color: "#673C8E", fontSize: "16px", fontWeight: 400 }}
                >
                  From
                </Typography>
                <LocalizationProvider
                  sx={{
                    "& .PrivatePickersPopperRoot-popupIndicator": {
                      display: "none",
                    },
                  }}
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    format="DD MMM YYYY"
                    value={dateFilter.from ? dayjs(dateFilter.from) : null}
                    onChange={(date) => {
                      if (!dayjs(date).isValid()) return;
                      return setDateFilter((dateFilter) => ({
                        ...dateFilter,
                        from: new Date(
                          new Date(date).setHours(0, 0, 0, 0)
                        ).toISOString(),
                      }));
                    }}
                    slotProps={{
                      textField: {
                        placeholder: "DD MMM YYYY",
                      },
                    }}
                    // value={filtrationData?.from ? dayjs(filtrationData.from) : null}
                    // onChange={(newValue) => {
                    //   const formattedDate = dayjs(newValue).toISOString();
                    //   setFiltrationData({
                    //     ...filtrationData,
                    //     from: formattedDate,
                    //   });
                    //   // handleFilterChange("from", formattedDate);
                    // }}
                    PopoverProps={{ disableEnforceFocus: true }} // Disable enforcing focus
                    sx={{
                      "& .MuiInputBase-input": {
                        paddingRight: "4px",
                        padding: "7px",
                        fontSize: "14px",
                        color: "#673C8E",
                        borderRadius: "14px",
                        border: "none", // Remove the border from the input
                      },
                      "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root": {
                        color: "#673C8E", // Change the color of the icon button
                      },
                      "& .MuiOutlinedInput-root": {
                        // borderRadius: "14px",
                      },
                      "& .MuiOutlinedInput-root fieldset": {
                        // border: "none",
                        border: "2px solid rgba(103, 60, 142, 1)",
                      },
                      "& .MuiOutlinedInput-root fieldset:hover": {
                        borderColor: "#673C8E", // Change border color on hover
                      },
                      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                        borderColor: "#673C8E", // Change border color when focused
                      },
                    }}
                    renderInput={(params) => (
                      <TextField placeholder="Select Date" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              <Box
                sx={{
                  width: "38%",
                  paddingLeft: "6px",
                  display: "flex",
                  borderRadius: "4px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                  // border: "2px solid rgba(103, 60, 142, 1)",
                }}
              >
                <Typography
                  sx={{ color: "#673C8E", fontSize: "16px", fontWeight: 400 }}
                >
                  To
                </Typography>
                <LocalizationProvider
                  sx={{
                    "& .PrivatePickersPopperRoot-popupIndicator": {
                      display: "none",
                    },
                  }}
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    format="DD MMM YYYY"
                    value={dateFilter.to ? dayjs(dateFilter.to) : null}
                    onChange={(date) => {
                      if (!dayjs(date).isValid()) return;
                      return setDateFilter((dateFilter) => ({
                        ...dateFilter,
                        to: new Date(
                          new Date(date).setHours(23, 59, 59, 999)
                        ).toISOString(),
                      }));
                    }}
                    slotProps={{
                      textField: {
                        placeholder: "DD MMM YYYY",
                      },
                    }}
                    // value={filtrationData?.from ? dayjs(filtrationData.from) : null}
                    // onChange={(newValue) => {
                    //   const formattedDate = dayjs(newValue).toISOString();
                    //   setFiltrationData({
                    //     ...filtrationData,
                    //     from: formattedDate,
                    //   });
                    //   // handleFilterChange("from", formattedDate);
                    // }}
                    PopoverProps={{ disableEnforceFocus: true }} // Disable enforcing focus
                    sx={{
                      "& .MuiInputBase-input": {
                        paddingRight: "4px",
                        padding: "7px",
                        fontSize: "14px",
                        color: "#673C8E",
                        borderRadius: "14px",
                        border: "none", // Remove the border from the input
                      },
                      "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root": {
                        color: "#673C8E", // Change the color of the icon button
                      },
                      "& .MuiOutlinedInput-root": {
                        // borderRadius: "14px",
                      },
                      "& .MuiOutlinedInput-root fieldset": {
                        // border: "none",
                        border: "2px solid rgba(103, 60, 142, 1)",
                      },
                      "& .MuiOutlinedInput-root fieldset:hover": {
                        borderColor: "#673C8E", // Change border color on hover
                      },
                      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                        borderColor: "#673C8E", // Change border color when focused
                      },
                    }}
                    renderInput={(params) => (
                      <TextField placeholder="Select Date" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Box>
              <Button
                onClick={onViewAllClick}
                sx={{
                  background: "rgba(103, 60, 142)",
                  color: "#fff",
                  padding: "4px 14px",
                  textTransform: "capitalize",
                  border: "none",
                  fontSize: "14px",
                  width: "90px",
                  outline: "none !important",
                  borderRadius: "4px",
                  "&:hover": {
                    color: "#fff",
                    background: "rgba(103, 60, 142)",
                  },
                  "&:focus": {
                    color: "#fff",
                    background: "rgba(103, 60, 142)",
                  },
                }}
              >
                View All
              </Button>
            </Box>
          </Grid>
        </>
      )}
      <Box
        sx={{
          width: "100%",
          height: "80vh",
          overflow: "auto",
          paddingRight: showAllReviews && "12px",
          marginTop: "16px",
        }}
      >
        {visibleReviews.length > 0 ? (
          visibleReviews.map((review, index) => (
            <DraggableReview
              showAllReviews={showAllReviews}
              key={index}
              review={review}
              onDrop={onDrop}
              setReviews={setReviews}
              dateFilter={dateFilter}
            />
          ))
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "260px",
              width: "100%",
              background: "#fff",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                color: "#A3A3A3",
              }}
            >
              No Reviews Found
            </Typography>
          </Box>
        )}
      </Box>
    </Grid>
  );
};

const DraggableReview = ({
  review,
  onDrop,
  showAllReviews,
  setReviews,
  dateFilter,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSubmit = async () => {
    try {
      if (review.clientRating.is_best) {
        await $crud.delete("admin/top-client-review", {
          orderId: review.orderId,
          id: review._id,
        });
      } else {
        await $crud.post("admin/top-client-review", {
          orderId: review.orderId,
        });
      }
      setOpenModal(false);

      const { data } = await $crud.retrieve("admin/client-reviews", {
        from: dateFilter.from,
        to: dateFilter.to,
      });
      setReviews(data.data);
    } catch (e) {
      console.error(e);
    }
  };

  const [, drag] = useDrag(() => ({
    type: "review",
    item: review,
    end: async (item, monitor) => {
      if (monitor.didDrop()) {
      }
    },
  }));

  return (
    <>
      <Grid item xs={12} ref={drag}>
        <Card
          sx={{
            background: "#FEFEFF",
            marginBottom: "15px",
            padding: "28px",
            paddingX: "40px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            gap: "24px",
            position: "relative",
          }}
        >
          {showAllReviews && (
            <Button
              onClick={() => {
                setOpenModal(true);
              }}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                background: "rgba(103, 60, 142)",
                color: "#fff",
                padding: "4px 14px",
                textTransform: "capitalize",
                border: "none",
                fontSize: "14px",
                // width: "90px",
                outline: "none !important",
                borderRadius: "4px",
                "&:hover": {
                  color: "#fff",
                  background: "rgba(103, 60, 142)",
                },
                "&:focus": {
                  color: "#fff",
                  background: "rgba(103, 60, 142)",
                },
              }}
            >
              {review.clientRating?.is_best
                ? "Remove from Top Review"
                : "Set as Top Review"}
            </Button>
          )}

          <Box display="flex" alignItems={"start"} gap="10px">
            <Box>
              <Avatar src={review?.clientRating?.photo} />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#000",
                      fontWeight: 600,
                    }}
                  >
                    {review?.driverName}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "32px",
                      marginTop: "5px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "9px",
                        color: "#000",
                        fontWeight: 400,
                      }}
                    >
                      {review.address || "NA"}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "9px",
                        color: "rgba(151, 151, 151, 1)",
                        fontWeight: 400,
                      }}
                    >
                      {toLocalTime(review.clientRating.createdAt)}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Typography
                sx={{
                  fontSize: "9px",
                  color: "#171A1F",
                  fontWeight: 400,
                  marginTop: "15px",
                }}
              >
                {review.clientRating?.review || "NA"}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "end",
              marginTop: showAllReviews ? "10px" : 0,
            }}
          >
            <Typography
              sx={{
                fontSize: "23px",
                color: "#171A1F",
                fontWeight: 700,
                px: "10px",
              }}
            >
              {review.clientRating?.rating}
            </Typography>
            <Box sx={{ display: "flex", gap: "5px" }}>
              {Array.from(
                { length: Math.floor(review.clientRating?.rating) },
                (_, i) => (
                  <StarIcon
                    sx={{ width: "15px", height: "15px", color: "#F7C705" }}
                  />
                )
              )}
            </Box>
          </Box>
        </Card>
      </Grid>
      {openModal && (
        <ClientReviewModel
          open={openModal}
          is_best={review.clientRating?.is_best}
          onSubmit={handleSubmit}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default OtherReviewClient;
